/* eslint-disable no-undef */
if (process.env.UMI_ENV === "prod") {
  module.exports = require("./config.prod").default;
} else {
  // } if (process.env.NODE_ENV ==='developement') {
  module.exports = require("./config.dev").default;
}
